"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        inputs: [],
        name: "AlreadyHasRole",
        type: "error",
    },
    {
        inputs: [],
        name: "BurnFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientFunds",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidValue",
        type: "error",
    },
    {
        inputs: [],
        name: "LockerActive",
        type: "error",
    },
    {
        inputs: [],
        name: "LockerNotActive",
        type: "error",
    },
    {
        inputs: [],
        name: "NotBurner",
        type: "error",
    },
    {
        inputs: [],
        name: "NotLocker",
        type: "error",
    },
    {
        inputs: [],
        name: "NotMinter",
        type: "error",
    },
    {
        inputs: [],
        name: "NotRequested",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroValue",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "TSTLockedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralTokenLockedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "netMinted",
                type: "uint256",
            },
        ],
        name: "ActivateLocker",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "burntAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "burningTime",
                type: "uint256",
            },
        ],
        name: "BurnByLocker",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "BurnerAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "BurnerRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "addedCollateral",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalCollateral",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "addingTime",
                type: "uint256",
            },
        ],
        name: "CollateralAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "removedCollateral",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalCollateral",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "removingTime",
                type: "uint256",
            },
        ],
        name: "CollateralRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "TSTLockedAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralTokenLockedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reliabilityFactor",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "addingTime",
                type: "uint256",
            },
        ],
        name: "LockerAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "teleBTCAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidateTime",
                type: "uint256",
            },
        ],
        name: "LockerLiquidated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "TSTUnlockedAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralTokenUnlockedAmount",
                type: "uint256",
            },
        ],
        name: "LockerRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardRecipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slashedCollateralAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slashTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isForCCBurn",
                type: "bool",
            },
        ],
        name: "LockerSlashed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "buyerAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slashingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "teleBTCAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slashingTime",
                type: "uint256",
            },
        ],
        name: "LockerSlashedCollateralSold",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "mintedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "mintingTime",
                type: "uint256",
            },
        ],
        name: "MintByLocker",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "MinterAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "MinterRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldBurnRouter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newBurnRouter",
                type: "address",
            },
        ],
        name: "NewBurnRouter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCollateralRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCollateralRatio",
                type: "uint256",
            },
        ],
        name: "NewCollateralRatio",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "decimal",
                type: "uint256",
            },
        ],
        name: "NewCollateralToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldLiquidationRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newLiquidationRatio",
                type: "uint256",
            },
        ],
        name: "NewLiquidationRatio",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldLockerPercentageFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newLockerPercentageFee",
                type: "uint256",
            },
        ],
        name: "NewLockerPercentageFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldMinRequiredTNTLockedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMinRequiredTNTLockedAmount",
                type: "uint256",
            },
        ],
        name: "NewMinRequiredTNTLockedAmount",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldMinRequiredTSTLockedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMinRequiredTSTLockedAmount",
                type: "uint256",
            },
        ],
        name: "NewMinRequiredTSTLockedAmount",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPriceOracle",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPriceOracle",
                type: "address",
            },
        ],
        name: "NewPriceOracle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldPriceWithDiscountRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newPriceWithDiscountRatio",
                type: "uint256",
            },
        ],
        name: "NewPriceWithDiscountRatio",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldReliabilityFactor",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newReliabilityFactor",
                type: "uint256",
            },
        ],
        name: "NewReliabilityFactor",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTST",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTST",
                type: "address",
            },
        ],
        name: "NewTST",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTeleBTC",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTeleBTC",
                type: "address",
            },
        ],
        name: "NewTeleBTC",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "TSTLockedAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralTokenLockedAmount",
                type: "uint256",
            },
        ],
        name: "RequestAddLocker",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "inactivationTimestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "TSTLockedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralTokenLockedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "netMinted",
                type: "uint256",
            },
        ],
        name: "RequestInactivateLocker",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "TSTLockedAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralTokenLockedAmount",
                type: "uint256",
            },
        ],
        name: "RevokeAddLockerRequest",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "HEALTH_FACTOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "INACTIVATION_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_LOCKER_FEE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NATIVE_TOKEN",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NATIVE_TOKEN_DECIMAL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ONE_HUNDRED_PERCENT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "TeleportSystemToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPPER_HEALTH_FACTOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "addBurner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_addingCollateralTokenAmount",
                type: "uint256",
            },
        ],
        name: "addCollateral",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_decimal",
                type: "uint256",
            },
        ],
        name: "addCollateralToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_lockerReliabilityFactor",
                type: "uint256",
            },
        ],
        name: "addLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "addMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "burnRouter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "burners",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_collateralAmount",
                type: "uint256",
            },
        ],
        name: "buySlashedCollateralOfLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "collateralDecimal",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "exchangeConnector",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
        ],
        name: "getLockerCapacity",
        outputs: [
            {
                internalType: "uint256",
                name: "theLockerCapacity",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
        ],
        name: "getLockerHealthFactor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "getLockerTargetAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
            {
                internalType: "address",
                name: "_priceOracle",
                type: "address",
            },
            {
                internalType: "address",
                name: "_burnRouter",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_minRequiredTSTLockedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_collateralRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_liquidationRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_lockerPercentageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_priceWithDiscountRatio",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
        ],
        name: "isLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
        ],
        name: "isLockerActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "libConstants",
        outputs: [
            {
                internalType: "uint256",
                name: "OneHundredPercent",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "HealthFactor",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "UpperHealthFactor",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "MaxLockerFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "NativeTokenDecimal",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "NativeToken",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "libParams",
        outputs: [
            {
                internalType: "address",
                name: "TeleportSystemToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "teleBTC",
                type: "address",
            },
            {
                internalType: "address",
                name: "burnRouter",
                type: "address",
            },
            {
                internalType: "address",
                name: "exchangeConnector",
                type: "address",
            },
            {
                internalType: "address",
                name: "priceOracle",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "minRequiredTSTLockedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minRequiredTNTLockedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lockerPercentageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "collateralRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "liquidationRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "priceWithDiscountRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "inactivationDelay",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_collateralAmount",
                type: "uint256",
            },
        ],
        name: "liquidateLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidationRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lockerCollateralToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lockerInactivationTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lockerLeavingAcceptance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockerPercentageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lockerReliabilityFactor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lockersMapping",
        outputs: [
            {
                internalType: "bytes",
                name: "lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "enum ScriptTypes",
                name: "lockerRescueType",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "lockerRescueScript",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "TSTLockedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "collateralTokenLockedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "netMinted",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "slashingTeleBTCAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reservedCollateralTokenForSlash",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isLocker",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "isCandidate",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "isScriptHash",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minRequiredTNTLockedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minRequiredTSTLockedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "minters",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseLocker",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_collateralToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_collateralDecimal",
                type: "uint256",
            },
        ],
        name: "priceOfOneUnitOfCollateralInBTC",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "priceOracle",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "priceWithDiscountRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "removeBurner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_removingCollateralTokenAmount",
                type: "uint256",
            },
        ],
        name: "removeCollateral",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
        ],
        name: "removeLockerByOwner",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "removeMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "requestActivation",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "requestInactivation",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_candidateLockingScript",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_collateralToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_lockedTSTAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_lockedCollateralTokenAmount",
                type: "uint256",
            },
            {
                internalType: "enum ScriptTypes",
                name: "_lockerRescueType",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "_lockerRescueScript",
                type: "bytes",
            },
        ],
        name: "requestToBecomeLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "revokeRequest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "selfRemoveLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_burnRouter",
                type: "address",
            },
        ],
        name: "setBurnRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_collateralRatio",
                type: "uint256",
            },
        ],
        name: "setCollateralRatio",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_liquidationRatio",
                type: "uint256",
            },
        ],
        name: "setLiquidationRatio",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
        ],
        name: "setLockerCollateralToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lockerPercentageFee",
                type: "uint256",
            },
        ],
        name: "setLockerPercentageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "reliabilityFactor",
                type: "uint256",
            },
        ],
        name: "setLockerReliabilityFactor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minRequiredTSTLockedAmount",
                type: "uint256",
            },
        ],
        name: "setMinRequiredTSTLockedAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_priceOracle",
                type: "address",
            },
        ],
        name: "setPriceOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_priceWithDiscountRatio",
                type: "uint256",
            },
        ],
        name: "setPriceWithDiscountRatio",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_TST",
                type: "address",
            },
        ],
        name: "setTST",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
        ],
        name: "setTeleBTC",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_rewardAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_slasher",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
        ],
        name: "slashIdleLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockerTargetAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_rewardAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_slasher",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "slashThiefLocker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "teleBTC",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalNumberOfCandidates",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalNumberOfLockers",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unPauseLocker",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
//# sourceMappingURL=LockersLogic.js.map